import {
  MFA_SESSION_HEADER,
  MFA_SESSION_STORAGE_KEY,
  POST,
  request,
  useEndpointsContext,
  useSessionStorage,
} from '@talos/kyoko';
import { useMutation, useMutationState } from '@tanstack/react-query';
import { v4 as uuid } from 'uuid';

export function useRequestAuthCode() {
  const { apiEndpoint } = useEndpointsContext();
  const [, setMfaSessionId] = useSessionStorage<string>(MFA_SESSION_STORAGE_KEY, '');
  const mutation = useMutation({
    mutationKey: ['requestAuthCode'],
    mutationFn: () => {
      const newMfaSessionId = uuid();
      setMfaSessionId(newMfaSessionId);
      return request(POST, apiEndpoint + '/mfa/generate-code', null, {
        headers: { [MFA_SESSION_HEADER]: newMfaSessionId },
      });
    },
  });
  const mutationState = useMutationState({
    filters: { mutationKey: ['requestAuthCode'] },
    select: mutation => mutation.state.status,
  }).at(-1);

  return {
    mutateAsync: mutation.mutateAsync,
    state: mutationState,
  };
}

export function useSubmitAuthCode() {
  const { apiEndpoint } = useEndpointsContext();
  const [mfaSessionId] = useSessionStorage<string>(MFA_SESSION_STORAGE_KEY, '');
  const mutation = useMutation({
    mutationKey: ['submitAuthCode'],
    mutationFn: async (code: string) => {
      return request(
        POST,
        apiEndpoint + '/mfa/verify-code',
        { Code: code },
        { headers: { [MFA_SESSION_HEADER]: mfaSessionId } }
      );
    },
  });
  const mutationState = useMutationState({
    filters: { mutationKey: ['submitAuthCode'] },
    select: mutation => mutation.state.status,
  }).at(-1);

  return {
    mutateAsync: mutation.mutateAsync,
    state: mutationState,
  };
}
